import { render, staticRenderFns } from "./IndexTags.vue?vue&type=template&id=2e2f526f"
import script from "./IndexTags.vue?vue&type=script&lang=js"
export * from "./IndexTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports